import React from 'react';

interface UsageBarProps {
    used: number;
    limit: number;
    plan: string;
}

const UsageBar: React.FC<UsageBarProps> = ({ used, limit, plan }) => {
    if (plan !== 'free') {
        return (
            <div className="flex items-center gap-2 text-sm text-success-400 font-medium">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Unlimited generations
            </div>
        );
    }

    const percent = Math.min((used / limit) * 100, 100);
    const isNearLimit = percent >= 70;
    const isAtLimit = used >= limit;

    const barColor = isAtLimit
        ? 'bg-danger-500'
        : isNearLimit
            ? 'bg-warning-500'
            : 'bg-primary-500';

    const textColor = isAtLimit
        ? 'text-danger-400'
        : isNearLimit
            ? 'text-warning-400'
            : 'text-white';

    return (
        <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
                <span className="text-dark-400">Today's Usage</span>
                <span className={`font-semibold ${textColor}`}>
                    {used} / {limit} used
                </span>
            </div>
            <div className="h-2 w-full bg-dark-700 rounded-full overflow-hidden">
                <div
                    className={`h-full rounded-full transition-all duration-700 ease-out ${barColor}`}
                    style={{ width: `${percent}%` }}
                />
            </div>
            {isAtLimit && (
                <p className="text-xs text-danger-400">Daily limit reached. Upgrade to continue generating.</p>
            )}
        </div>
    );
};

export default UsageBar;
